var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "coverage__app" }, [
    _c("div", { staticClass: "coverage__header" }, [
      _c("div", { staticClass: "mt-3 mb-1 mb-sm-3" }, [
        _c(
          "button",
          {
            class: { active: _vm.activeSport == "football" },
            on: {
              click: function ($event) {
                _vm.activeSport = "football"
              },
            },
          },
          [_vm._v("Football")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            class: { active: _vm.activeSport == "other_sports" },
            on: {
              click: function ($event) {
                _vm.activeSport = "other_sports"
              },
            },
          },
          [_vm._v("Other Sports")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-3 d-flex flex-column flex-md-row" }, [
        _c("div", { staticClass: "search_wrap" }, [
          _c("input", {
            attrs: {
              type: "text",
              id: "search",
              name: "search",
              placeholder: "Search",
              autocomplete: "off",
            },
            on: { input: _vm.debounceInput },
          }),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.activeSport == "football" && _vm.download.soccer
            ? _c(
                "a",
                {
                  staticClass: "coverage__download",
                  attrs: {
                    href: _vm.download.soccer.url
                      ? _vm.download.soccer.url
                      : _vm.download.soccer,
                    target: "_blank",
                  },
                },
                [_vm._v("Download full overview")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeSport == "other_sports" && _vm.download.other_sports
            ? _c(
                "a",
                {
                  staticClass: "coverage__download",
                  attrs: {
                    href: _vm.download.other_sports.url
                      ? _vm.download.other_sports.url
                      : _vm.download.other_sports,
                    target: "_blank",
                  },
                },
                [_vm._v("Download full overview")]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.note
          ? _c("div", {
              staticClass: "px-md-4 small",
              domProps: { innerHTML: _vm._s(_vm.note) },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("table", [
        _c(
          "tr",
          [
            _c("td", { staticClass: "coverage__explainers" }, [
              _c("span", [_c("IconPre"), _vm._v("Pre match")], 1),
              _vm._v(" "),
              _c("span", [_c("IconLive"), _vm._v("Live")], 1),
              _vm._v(" "),
              _c("span", [_c("IconPost"), _vm._v("Post Match")], 1),
            ]),
            _vm._v(" "),
            _vm._l(
              _vm.coverage[this.activeSport],
              function (description, type) {
                return _c(
                  "td",
                  { staticClass: "coverage__type" },
                  [
                    _c("span", {
                      staticClass: "coverage__type-text",
                      domProps: { innerHTML: _vm._s(type) },
                    }),
                    _vm._v(" "),
                    _c("IconInfo"),
                    _vm._v(" "),
                    _c("div", { staticClass: "coverage__type-description" }, [
                      _vm._v(_vm._s(description)),
                    ]),
                  ],
                  1
                )
              }
            ),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "coverage__innerwrapper" },
      [
        Object.keys(_vm.filteredData).length === 0
          ? _c("div", { staticClass: "mt-5 bm-5 text-center" }, [
              _c("h5", [
                _vm._v("No entries found. Try broaden your search a bit!"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.filteredData, function (leagues, country) {
          return _vm.activeSport == "football"
            ? _c("div", { staticClass: "groupedLeagues" }, [
                _c("h5", [
                  _c("span", {
                    class:
                      "fi fis fi-" + leagues[0].country.value.toLowerCase(),
                  }),
                  _vm._v("\n        " + _vm._s(country) + "\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "table",
                  _vm._l(_vm.sortByTitle(leagues), function (league) {
                    return _c(
                      "tr",
                      { attrs: { tabindex: "0" } },
                      [
                        _c("td", {
                          staticClass: "league-title",
                          domProps: { innerHTML: _vm._s(league.title) },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.coverage[_vm.activeSport],
                          function (value, coverage_type) {
                            return _c(
                              "td",
                              [
                                league.coverage[coverage_type] === "b"
                                  ? _c("IconPre")
                                  : _vm._e(),
                                _vm._v(" "),
                                league.coverage[coverage_type] === "l"
                                  ? _c("IconLive")
                                  : _vm._e(),
                                _vm._v(" "),
                                league.coverage[coverage_type] === "a"
                                  ? _c("IconPost")
                                  : _vm._e(),
                                _vm._v(" "),
                                league.coverage[coverage_type] === "none"
                                  ? _c("IconPre", {
                                      staticStyle: { opacity: "0" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(
          _vm.sortObjectByKey(_vm.filteredData),
          function (leagues, sport) {
            return _vm.activeSport == "other_sports"
              ? _c("div", { staticClass: "groupedLeagues" }, [
                  _c("h5", [_vm._v(_vm._s(sport))]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(_vm.sortByTitle(leagues), function (league) {
                      return _c(
                        "tr",
                        { attrs: { tabindex: "0" } },
                        [
                          _c("td", [
                            _c("span", {
                              class:
                                "fi fis fi-" +
                                league.country.value.toLowerCase(),
                            }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(league.title) },
                            }),
                          ]),
                          _vm._v(" "),
                          _vm._l(league.coverage, function (value, coverage) {
                            return _c(
                              "td",
                              [
                                value === "b" ? _c("IconPre") : _vm._e(),
                                _vm._v(" "),
                                value === "l" ? _c("IconLive") : _vm._e(),
                                _vm._v(" "),
                                value === "a" ? _c("IconPost") : _vm._e(),
                                _vm._v(" "),
                                value === "none"
                                  ? _c("IconPre", {
                                      staticStyle: { opacity: "0" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e()
          }
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }